/** Обновлять access-токен заранее, чтобы запрос не ушёл уже с просроченным JWT. */
export const ACCESS_REFRESH_SKEW_MS = 2 * 60 * 1000

/** Скрытая вкладка без действий не продлевает сессию. */
export const SESSION_ACTIVITY_WINDOW_MS = 15 * 60 * 1000

export function jwtExpiresAtMs(token: string | null): number | null {
  if (!token) return null
  const part = token.split('.')[1]
  if (!part) return null
  try {
    const padded = part.replace(/-/g, '+').replace(/_/g, '/').padEnd(Math.ceil(part.length / 4) * 4, '=')
    const payload = JSON.parse(atob(padded))
    return typeof payload.exp === 'number' ? payload.exp * 1000 : null
  } catch {
    return null
  }
}

export function shouldRefreshAccessToken(input: {
  now: number
  accessExpiresAtMs: number | null
  hasRefreshToken: boolean
  tabVisible: boolean
  lastActivityAt: number
}): boolean {
  const recentlyActive = input.now - input.lastActivityAt < SESSION_ACTIVITY_WINDOW_MS
  const keepSession = input.tabVisible || recentlyActive
  if (!keepSession) return false

  if (input.accessExpiresAtMs == null) return input.hasRefreshToken

  const msLeft = input.accessExpiresAtMs - input.now
  if (msLeft >= ACCESS_REFRESH_SKEW_MS) return false
  if (msLeft <= 0 && !input.hasRefreshToken) return false
  return true
}
